import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";

export const EstimatesIcon = CalculateOutlinedIcon;
export const PricelistsIcon = LocalOfferOutlinedIcon;
